/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { ApplicationCredentialsDto, FindApplicationsParams } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class OrganisationApplicationController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags organisation-application-controller
   * @name FindApplications
   * @request GET:/api/v1/organisation/applications
   */
  findApplications = (query: FindApplicationsParams, params: RequestParams = {}) =>
    this.http.request<ApplicationCredentialsDto[], any>({
      path: `/v1/organisation/applications`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static findApplicationsPath = '/v1/organisation/applications'
  static findApplicationsMethod = 'GET'
}
